import {ReportAssetChildrenModel} from "../../models/reports/ReportAssetChildrenModel";

export class ReportAssetChildrenCtrl {
    public static $inject = ['$scope','ReportAssetChildrenModel'];
    constructor(public $scope:any, public model:ReportAssetChildrenModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.name], (newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
